import axios from 'axios'
import HitModel from '@/services/Models/HitModel'
import PlayerModel from '@/services/Models/PlayerModel'

export default {
  getList(config) {
    let url = (config && config.next_page_url) || '/players'

    return axios.get(url, {
      params: {
        my_school: config && config.my_school,
        league: config && config.league
      }
    })
    .then(mapToPlayers)
  },

  getPlayer(id) {
    return axios.get('players/' + id)
      .then(mapToPlayer)
  },

  update(id, data) {
    return axios.put('players/' + id, data)
      .then(mapToPlayer)
  },

  getHits(player_id, config) {
    let url = (config && config.next_page_url) || 'players/' + player_id + '/hits'

    return axios.get(url)
      .then(mapToHits)
  }
}

function mapToPlayer(response) {
  return PlayerModel(response.data)
}

function mapToPlayers(response) {
  response.data.data = response.data.data.map(PlayerModel)

  return response.data
}

function mapToHits(response) {
  response.data.data = response.data.data.map(HitModel)

  return response.data
}



// WEBPACK FOOTER //
// ./src/services/Api/PlayerApi.js